/*
 * @Author: gaobin
 * @Date: 2025-03-26 10:30:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-20 11:59:42
 * @Description: 订单
 */
const orderMap = {
  // 获取我的订单列表
  getOrderPageExt: '/usb/uwb-app/api/v1/order/getOrderPage',
  // 获取订单详情信息
  getOrderDetailExt: '/usb/uwb-app/api/v1/order/getOrderDetail',
  // 取消订单
  cancelOrderExt: '/usb/uwb-app/api/v1/order/cancelOrder',
  // 确认订单
  confirmOrderExt: '/usb/uwb-app/api/v1/order/confirmOrder',
  // 获取订单状态数量
  getStatusCountExt: '/usb/uwb-app/api/v1/order/getStatusCount',
  // 获取物流详情
  getLogisticsDetailsExt: '/usb/uwb-app/api/v1/track',
  // 确认收货
  confirmGoodsExt: '/usb/uwb-app/api/v1/order/confirmOrder',
  // 修改地址
  updateAddressExt: '/usb/uwb-app/api/v1/order/updateOrderAddress',
  // 添加备注
  addRemarkExt: '/usb/uwb-app/api/v1/order/updateOrderRemark',
  // 获取订单物流状态
  getLogisticsStatusExt: '/usb/uwb-app/api/v1/product/logisticsFreight',
  // 提交物流状态
  updateOrderLogistic: '/usb/uwb-app/api/v1/order/updateOrderLogistic',
};

export default orderMap;
